module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Media-folder-680a40e38fc8487391ba30cb963a1875.svg";